/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconPictureInPictureTop = createReactComponent("outline", "picture-in-picture-top", "IconPictureInPictureTop", [["path", { "d": "M11 5h-6a2 2 0 0 0 -2 2v10a2 2 0 0 0 2 2h14a2 2 0 0 0 2 -2v-4", "key": "svg-0" }], ["path", { "d": "M15 10h5a1 1 0 0 0 1 -1v-3a1 1 0 0 0 -1 -1h-5a1 1 0 0 0 -1 1v3a1 1 0 0 0 1 1z", "key": "svg-1" }]]);

export { IconPictureInPictureTop as default };
//# sourceMappingURL=IconPictureInPictureTop.mjs.map
